import React, { useState, useEffect } from 'react';
import Chart from "react-google-charts";
import {
  GoogleChartEditor,
  GoogleChartWrapper,
  GoogleViz,
  GoogleChartWrapperChartType,
} from 'react-google-charts/dist/types';

import Select from '@material-ui/core/Select';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import moment from 'moment'
import clsx from "clsx";
import html2canvas from 'html2canvas';

import {
  apollo_useStyles,
  Option,
} from "../../atom/Apollo_styles_Beta";
import {
  options_download_kind,
  options_setpoint_columns,
  options_graph_campaign,
  options_graph_adgroup,
  options_graph_zeus,
} from '../../atom/Apollo_Options';
import {
  ChartColumnData,
  ChartColumns1,
  ChartColumns2,
  ChartColumns3,
  INIT_YEAR_DATE,
  DOWNLOAD_KIND,
  SUMMARY_GRAPH_HEADERS,
} from "../../common/Apollo_CommonConst_Beta";
import { valueToLabel } from "../../common/Apollo_CommonUtil_Beta";
import { ApolloIconButtonDownloadImage } from "../../molecule/Apollo_IconButtonBase_Beta";
import {APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_SYSTEM_ADMIN, IsAuthorization} from "../../atom/Apollo_Authorization";

type ChartData = (string | number)[][]

export interface LineChartProps {
  startDate: string;
  endDate: string;
  previousStartDate: string;
  previousEndDate: string;
  inputData: (string | number)[][];
  previousInputData: (string | number)[][];
  chartPtn?: number;
  storageKeyGraph1: string;
  storageKeyGraph2: string;
  fileName?: string,
  loadingChart?: boolean;
  onLoadChart?: any;
  isAutoDisplayChecked?: boolean;
  setIsAutoDisplayChecked?: any;
  isPreviousPeriodChecked: boolean;
  setIsPreviousPeriodChecked: any;
  isPreviousPeriodDisabled?: boolean;
  isChartDataLoaded: boolean;
  setPoints: Option[],
}

export const LintChartColumnsPtn = {
  Ptn1: 1,
  Ptn2: 2,
  Ptn3: 3,
}

export const LintChartStorageKey = {
  ZeusAdGroupListGraph1: "ZeusAdGroupList_LineChart_Graph1",
  ZeusAdGroupListGraph2: "ZeusAdGroupList_LineChart_Graph2",
  MsAdGroupListGraph1: "MsAdGroupList_LineChart_Graph1",
  MsAdGroupListGraph2: "MsAdGroupList_LineChart_Graph2",
  ZeusAdvertisementGraph1: "ZeusAdvertisement_LineChart_Graph1",
  ZeusAdvertisementGraph2: "ZeusAdvertisement_LineChart_Graph2",
  MsAdvertisementsListGraph1: "MsAdvertisementsList_LineChart_Graph1",
  MsAdvertisementsListGraph2: "MsAdvertisementsList_LineChart_Graph2",
  AccountSummaryGraph1: "AccountSummary_LineChart_Graph1",
  AccountSummaryGraph2: "AccountSummary_LineChart_Graph2",
  IndividualSummaryGraph1: "IndividualSummary_LineChart_Graph1",
  IndividualSummaryGraph2: "IndividualSummary_LineChart_Graph2",
}

export const LineChart: React.FC<LineChartProps> = (props) => {

  const classes = apollo_useStyles();
  const fixedHeightPaper = clsx(classes.summarypaper, classes.fixedHeightGraph);

  const [component, setState] = React.useState<{ chartEditor: GoogleChartEditor | null, chartWrapper: GoogleChartWrapper | null, google: GoogleViz | null }>(
    {chartEditor: null, chartWrapper: null, google: null})

  const [graphData, setData] = React.useState(props.inputData)
  const [graph1, setGraphVValue1] = React.useState(1)
  const [graph2, setGraphVValue2] = React.useState(2)
  const [chartType, setChartType] = React.useState<GoogleChartWrapperChartType>("LineChart")

  const storageKeyGraph1 = props.storageKeyGraph1
  const storageKeyGraph2 = props.storageKeyGraph2
  const tmpFileName = props.fileName ? props.fileName : "";
  const mergedSetPoints = [...props.setPoints];
  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);

  React.useEffect(() => {
    if (localStorage.getItem(storageKeyGraph1) && graphData[0][Number(localStorage.getItem(storageKeyGraph1))] !== undefined) {
      setGraphVValue1(Number(localStorage.getItem(storageKeyGraph1)));
    }
    if (localStorage.getItem(storageKeyGraph2) && graphData[0][Number(localStorage.getItem(storageKeyGraph2))] !== undefined) {
      setGraphVValue2(Number(localStorage.getItem(storageKeyGraph2)));
    }
  }, []);
  const handleChangeGraph1 = (event: React.ChangeEvent<{ value: unknown }>) => {
    setGraphVValue1(Number(event.target.value));
    localStorage.setItem(storageKeyGraph1, String(event.target.value));
  };
  const handleChangeGraph2 = (event: React.ChangeEvent<{ value: unknown }>) => {
    setGraphVValue2(Number(event.target.value));
    localStorage.setItem(storageKeyGraph2, String(event.target.value));
  };

  const generate_setpoint_options_format = (): { [index: number]: string } => {
    var local_setpoint_options_format: { [index: number]: string } = {}
    var options_value = SUMMARY_GRAPH_HEADERS.length;
    for (let column of options_setpoint_columns) {
      var ret = "";
      switch (column.label) {
        case 'ラストクリックCV':
        case 'アシストクリックCV':
          ret = 'decimal';
          break;
        case 'ラストクリックCVR':
          ret = 'percent';
          break;
        case 'ラストクリックCPA':
          ret = '¥#,###';
          break;
        default:
          ret = 'decimal';
          break;
      }
      for (let _ of mergedSetPoints) {
        local_setpoint_options_format[options_value] = ret;
        options_value++
      }
    }
    return local_setpoint_options_format;
  };

  const options_format: { [index: number]: string } = {
    1: '¥#,###',
    2: 'decimal',
    3: 'decimal',
    4: 'decimal',
    5: '#.###%',
    6: '#.###%',
    7: 'decimal',
    8: 'decimal',
    9: 'decimal',
    10: 'decimal',
    11: 'decimal',
    12: '#.###%',
    13: '#.###%',
    14: '#.###%',
    15: '¥#,###',
    16: '¥#,###',
    17: '¥#,###',
    18: 'decimal',
    19: '#.###%',
    20: '¥#,###',
    ...generate_setpoint_options_format(),
  }

  function date_options_format(dateStr: string): string {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = moment(dateStr).format('ddd');
    var ret = `${month}/${day}(${dayOfWeek})`;

    return ret;
  }

  function year_date_options_format(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const ret = `${year}/${month}/${day}`;

    return ret;
  }

  const options_list = generate_setpoint_options_list(props.chartPtn === LintChartColumnsPtn.Ptn3 ? options_graph_zeus : props.chartPtn === LintChartColumnsPtn.Ptn2 ? options_graph_adgroup : options_graph_campaign, SUMMARY_GRAPH_HEADERS.length, mergedSetPoints);

  function convertTooltip(graphData: (string | number)[][], previousGraphData: (string | number)[][]): (string | number | null)[][] {
    var resultGraphData: (any)[][] = [];
    var indexData: string[] = [];
    indexData[0] = '';
    indexData[1] = '';
    for (var i = 0; i < graphData.length; i++) {
      var value = graphData[i];
      if (props.isPreviousPeriodChecked) {
        if (i == 0) {
          indexData[0] = String(value[graph1]);
          indexData[1] = String(value[graph2]);
          resultGraphData.push([value[0], value[graph1], {
            role: "tooltip",
            type: "string",
            p: {html: true}
          }, value[graph2], {role: "tooltip", type: "string", p: {html: true}},
          value[graph1]+'(前期間)', {
            role: "tooltip",
            type: "string",
            p: {html: true}
          }, value[graph2]+'(前期間)', {role: "tooltip", type: "string", p: {html: true}}]);
        } else {
          var previousValue:(string | number)[] = [];
          if (previousGraphData[i] !== undefined) {
            previousValue = previousGraphData[i];
          } else {
            previousValue = [INIT_YEAR_DATE, ...Array<number>(SUMMARY_GRAPH_HEADERS.length-1+(options_setpoint_columns.length*mergedSetPoints.length)).fill(0)];
          }
          resultGraphData.push([date_options_format(String(value[0])), value[graph1], tooltip_options_format(String(value[0]), indexData[0], value[graph1]), value[graph2], tooltip_options_format(String(value[0]), indexData[1], value[graph2]),previousValue[graph1], tooltip_options_format(String(previousValue[0]), indexData[0], previousValue[graph1]), previousValue[graph2], tooltip_options_format(String(previousValue[0]), indexData[1], previousValue[graph2])]);
        }
      } else {
        if (i == 0) {
          indexData[0] = String(value[graph1]);
          indexData[1] = String(value[graph2]);
          resultGraphData.push([value[0], value[graph1], {
            role: "tooltip",
            type: "string",
            p: {html: true}
          }, value[graph2], {role: "tooltip", type: "string", p: {html: true}}]);
        } else {
          resultGraphData.push([date_options_format(String(value[0])), value[graph1], tooltip_options_format(String(value[0]), indexData[0], value[graph1]), value[graph2], tooltip_options_format(String(value[0]), indexData[1], value[graph2])]);
        }
      }
    }
    return resultGraphData
  }

  const handleDownload = () => {
    const fileName = tmpFileName !== "" ? tmpFileName : "chart.csv";
    const csvData = formatChartCsvData(props.inputData, props.chartPtn === LintChartColumnsPtn.Ptn3 ? ChartColumns3 : props.chartPtn === LintChartColumnsPtn.Ptn2 ? ChartColumns2 : ChartColumns1, SUMMARY_GRAPH_HEADERS, mergedSetPoints);
    const data = csvData.map(e => e.join(",")).join("\n");
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, data], {type: 'text/csv'});

    const link = document.createElement("a");
    link.setAttribute("href", window.URL.createObjectURL(blob));
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();
  }

  const handleDownloadImage = (value: number) => {
    const fileFormat = valueToLabel(value, options_download_kind);
    const fileName = tmpFileName !== "" ? tmpFileName.replace(valueToLabel(DOWNLOAD_KIND.CSV, options_download_kind), fileFormat) : `chart.${fileFormat}`;
    const chartNode = document.getElementById("chart-container");

    if (chartNode !== null) {
      html2canvas(chartNode, { scale: 2 }).then((canvas) => {
        const link = document.createElement("a");
        link.setAttribute("href", canvas.toDataURL(`image/${fileFormat}`));
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      });
    }
  }

  function getUnifiedViewWindowAndTicks(
  maxValue: number,
  prevMaxValue: number = 0
  ): {
    viewWindow?: { min: number; max: number };
    ticks?: number[];
  } {
    // 前期間も含めた最大値を考慮
    const combinedMax = Math.max(maxValue, prevMaxValue);
  
    if (combinedMax === 0) {
      // データが完全に0ならデフォルト自動スケール
      return {};
    }
  
    if (combinedMax <= 0.002) {
      const step = Math.ceil((combinedMax * 10000) / 5) / 10000;
      const maxCeil = step * 5;
      return {
        viewWindow: { min: 0, max: maxCeil },
        ticks: Array.from({ length: 6 }, (_, i) => i * step),
      };
    } else if (combinedMax <= 0.01) {
      const step = Math.ceil((combinedMax * 1000) / 5) / 1000;
      const maxCeil = step * 5;
      return {
        viewWindow: { min: 0, max: maxCeil },
        ticks: Array.from({ length: 6 }, (_, i) => i * step),
      };
    } else {
      // 大きい値なら自動スケール
      return {};
    }
  }

  const previousChecked = !!props.isPreviousPeriodChecked;
  // 非管理者のとき、前期間データに 2025-09-30 以前が含まれるか
  const hasForbiddenPrevDate =
    previousChecked &&
    props.previousInputData.some((row, index) => {
      if (index === 0) return false; // ヘッダーは無視
      const dateStr = String(row[0]);
      if (!moment(dateStr, "YYYY-MM-DD", true).isValid()) return false;
      return moment(dateStr).isSameOrBefore("2025-09-30", "day");
    });

  // 仕様に基づく表示可否（文言 & グラフ 共通判定）
  const showPrevious =
    previousChecked && (isAuthorization || (!isAuthorization && !hasForbiddenPrevDate));

  const max1 = Math.max(...graphData.slice(1).map(row => Number(row[graph1]) || 0));
  const max2 = Math.max(...graphData.slice(1).map(row => Number(row[graph2]) || 0));
  let prevMax1 = 0;
  let prevMax2 = 0;

  if (showPrevious) {
    prevMax1 = Math.max(...props.previousInputData.slice(1).map(row => Number(row[graph1]) || 0));
    prevMax2 = Math.max(...props.previousInputData.slice(1).map(row => Number(row[graph2]) || 0));
  }

  // isPreviousPeriodChecked が true の場合だけ previousInputData を考慮
  const { viewWindow: viewWindow1, ticks: ticks1 } = getUnifiedViewWindowAndTicks(
    max1,
    showPrevious ? prevMax1 : 0
  );
  const { viewWindow: viewWindow2, ticks: ticks2 } = getUnifiedViewWindowAndTicks(
    max2,
    showPrevious ? prevMax2 : 0
  );
 
  const rawChartData = convertTooltip(graphData, props.previousInputData);
  const chartData: (string | number | null)[][] = showPrevious
  ? rawChartData
  : rawChartData.map((row, idx) => {
      if (idx === 0) return row;
      const newRow = [...row];
      if (newRow.length >= 9) {
        newRow[5] = NaN;
        newRow[6] = '';
        newRow[7] = NaN;
        newRow[8] = '';
      }
      return newRow;
    });

  return (
    <React.Fragment>
      <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
        <Grid item xs={props.onLoadChart !== undefined?2:3}>
          <Select
            native
            value={graph1}
            onChange={handleChangeGraph1}
          >
            {options_list}
          </Select>
        </Grid>
        <Grid item xs={props.onLoadChart !== undefined?2:3}>
          <Select
            native
            value={graph2}
            onChange={handleChangeGraph2}
          >
            {options_list}
          </Select>
        </Grid>
        {props.onLoadChart &&
          <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" color="primary" onClick={props.onLoadChart} disabled={props.loadingChart || props.isAutoDisplayChecked}>グラフ表示</Button>
          </Grid>
        }
        <Grid item xs={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
            {props.onLoadChart &&
              <FormControlLabel
                label={"グラフ自動表示"}
                control={<Checkbox checked={props.isAutoDisplayChecked} onChange={() => props.setIsAutoDisplayChecked(!props.isAutoDisplayChecked)} />}
              />
            }
            <FormControlLabel
              label={"前期間表示"}
              control={<Checkbox checked={props.isPreviousPeriodChecked} onChange={() => props.setIsPreviousPeriodChecked(!props.isPreviousPeriodChecked)} disabled={props.isPreviousPeriodDisabled !== undefined ? props.isPreviousPeriodDisabled : false}/>}
            />
          </Box>
        </Grid>
        {props.onLoadChart ?
          <Grid item xs={1}>
            <Tooltip title="CSVダウンロード">
              <IconButton aria-label="download" onClick={() => handleDownload()}>
                <CloudDownloadIcon/>
              </IconButton>
            </Tooltip>
          </Grid>
          :
          <Grid item xs={2}>
            <ApolloIconButtonDownloadImage handleDownload={handleDownload} handleDownloadImage={handleDownloadImage} title={"ダウンロード"}/>
          </Grid>
        }
      </Grid>
      <Grid container spacing={1} justify="center">
        <Grid item xs={12} lg={12}>
          <div id="chart-container">
            {props.isChartDataLoaded && (
              <p style={{ textAlign: "center" }}>
                表示期間：{year_date_options_format(props.startDate)}~{year_date_options_format(props.endDate)}
                {showPrevious && ` （前期間：${year_date_options_format(props.previousStartDate)}~${year_date_options_format(props.previousEndDate)}）`}
              </p>
            )}
            <Chart
              chartType={chartType}
              width={"100%"}
              height={"460px"}
              loader={<div>Loading Chart・・・・・・・</div>}
              data={chartData}
              rootProps={{'data-testid': '1'}}
              getChartEditor={({chartEditor, chartWrapper, google}) => {
                setState({chartEditor, chartWrapper, google})
              }}
              chartPackages={['corechart', 'controls', 'charteditor']}
              options={{
                series: {
                  0: {targetAxisIndex: 0},
                  1: {targetAxisIndex: 1},
                  2: {targetAxisIndex: 0, lineDashStyle: [2, 2], visibleInLegend: showPrevious},
                  3: {targetAxisIndex: 1, lineDashStyle: [2, 2], visibleInLegend: showPrevious},
                },
                legend: {
                  maxLines: 4, // 表示する項目の最大数を指定
                  textStyle: {
                    fontSize: 12, // テキストのフォントサイズを指定
                  },
                },
                vAxes: {
                  0: {
                    title: graphData[0][graph1],
                    format: options_format[graph1],
                    minorGridlines: {count: 0},
                    minValue: 0,
                    ...(viewWindow1 && { viewWindow: viewWindow1 }),
                    ...(ticks1      && { ticks:      ticks1 }),
                    gridlines: { color: '#e0e0e0' },
                  },
                  1: {
                    title: graphData[0][graph2],
                    format: options_format[graph2],
                    minorGridlines: {count: 0},
                    minValue: 0,
                    ...(viewWindow2 && { viewWindow: viewWindow2 }),
                    ...(ticks2      && { ticks:      ticks2 }),
                    gridlines: { color: '#e0e0e0' },
                  },
                  2: {
                    title: graphData[0][graph1]+'(前期間)',
                    format: options_format[graph1],
                    minorGridlines: {count: 0},
                    minValue: 0,
                  },
                  3: {
                    title: graphData[0][graph2]+'(前期間)',
                    format: options_format[graph2],
                    minorGridlines: {count: 0},
                    minValue: 0,
                  }
                },
                theme: "material",
                colors: ['#29b6f6', '#ff8a65','#29b6f6', '#ff8a65'],
              }}
            />
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export const formatChartCsvData = (data: any[][], columnData: ChartColumnData[], headers: string[], setPoints: Option[]): string[][] => {
  const localData: any[][] = data.slice();
  const csvData: string[][] = [];
  const header = columnData.map(c => c.label);
  csvData.push(generateCsvHeader(header, setPoints));
  localData.shift();
  localData?.map((d,) => {
    const rows: string[] = [];
    d?.map((v, idx) => {
      const column = columnData.filter((c: ChartColumnData) => c.index === idx);
      if (!column || column.length === 0) return;
      const c = column[0];
      switch (c.viewPattern) {
        case 1:
        case 2:
          rows.push(v);
          break;

        case 3:
          rows.push(`￥${v}`);
          break;

        case 4:
          rows.push(`${Number(v * 100).toFixed(2)}%`);
          break;

        case 5:
          rows.push(v);
          rows.push(...generateSetPointColumns(d, headers, 0, c.viewPattern, setPoints))
          break;

        case 6:
          rows.push(v);
          rows.push(...generateSetPointColumns(d, headers, 1, c.viewPattern, setPoints))
          break;

        case 7:
          rows.push(`${Number(v * 100).toFixed(2)}%`);
          rows.push(...generateSetPointColumns(d, headers, 2, c.viewPattern, setPoints))
          break;

        case 8:
          rows.push(`￥${v}`);
          rows.push(...generateSetPointColumns(d, headers, 3, c.viewPattern, setPoints))
          break;

        default:
          break;
      }
    });
    if (rows.length > 0) csvData.push(rows);
  });

  return csvData;
}

export const generateCsvHeader = (headers: string[], setPoints: Option[]): string[] => {
  let new_columns: string[] = JSON.parse(JSON.stringify([...headers]));
  let setpoint_columns_length = 0;

  headers.forEach((column, index) => {
    options_setpoint_columns.map(option => {
      if (option.label === column.replace("(合計)", "")) {
        const local_setpoint_columns:string[] = [];
        for (const setpoint of setPoints) {
          local_setpoint_columns.push(column.replace("合計", setpoint.label));
        }
        new_columns.splice(index+setpoint_columns_length+1, 0, ...local_setpoint_columns);
        setpoint_columns_length += local_setpoint_columns.length;
      }
    });
  });

  return new_columns;
}

export const generateSetPointColumns = (data: any[], headers: string[], idx: number, viewPattern: number, setPoints: Option[]): string[] => {
  let local_setpoint_rows:string[] = [];
  var index = headers.length + idx*setPoints.length;
  for (let i = 0; i < setPoints.length; i++) {
    switch (viewPattern) {
      case 5:
      case 6:
        local_setpoint_rows.push(data[index+i]);
        break;

      case 7:
        local_setpoint_rows.push(`${Number(data[index+i] * 100).toFixed(2)}%`);
        break;

      case 8:
        local_setpoint_rows.push(`￥${data[index+i]}`);
        break;

      default:
        break;
    }
  }
  return local_setpoint_rows;
};

export const generate_setpoint_options_list = (options_graph: Option[], options_value: number, mergedSetPoints: Option[]): JSX.Element => {

  return (
    <React.Fragment>
      {options_graph.map((option) => {
        if (options_setpoint_columns.some((item) => item.label === option.label)) {
          if (option.label !== "ラストクリックCV") options_value += mergedSetPoints.length;
          return (
            <React.Fragment key={option.value}>
              <optgroup label={option.label}>
                <option value={option.value}>{"合計"}</option>
                {mergedSetPoints.map((setPoint, index) => (
                  <option key={options_value + index} value={options_value + index}>{setPoint.label}</option>
                ))}
              </optgroup>
            </React.Fragment>
          );
        } else {
          return (
            <option key={option.value} value={option.value}>{option.label}</option>
          );
        }
      })}
    </React.Fragment>
  );
};

export function tooltip_options_format(date: string, index: string, value: string | number): string {
  var ret = date + '\r\n' + index + ':';
  var valueParam = "";
  if (typeof value == "string") {
    valueParam = value;
  } else {
    valueParam = String(value)
  }

  var labels = index.split("(");
  if (options_setpoint_columns.some((item) => item.label === labels[0])) {
    for (let column of options_setpoint_columns) {
      if (labels[0] === column.label){
        switch (column.label) {
          case 'ラストクリックCV':
          case 'アシストクリックCV':
            ret += valueParam;
            break;
          case 'ラストクリックCVR':
            ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
            break;
          case 'ラストクリックCPA':
            ret += `¥${valueParam}`;
            break;
          default:
            break;
        }
      }
    }
  } else {
    switch (index) {
      case 'cost':
        ret += '¥' + valueParam;
        break;
      case 'CTR':
        ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
        break;
      case 'vCTR':
        ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
        break;
      case '平均CPC':
        ret += '¥' + valueParam;
        break;
      case 'CPM':
        ret += '¥' + valueParam;
        break;
      case 'CVR(合計)':
        ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
        break;
      case 'アシストクリックCVR(合計)':
        ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
        break;
      case 'CPA(合計)':
        ret += '¥' + valueParam;
        break;
      case 'アシストクリックCPA(合計)':
        ret += '¥' + valueParam;
        break;
      case '最適化ポイントCVR':
        ret += String((Number(valueParam) * 100).toFixed(2)) + '%';
        break;
      case '最適化ポイントCPA':
        ret += '¥' + valueParam;
        break;
      default:
        ret += valueParam;
        break;
    }
  }

  return ret;
}